export const period = [
  {
    label: 'Once',
    value: 'ONCE'
  },
  {
    label: 'Monthly',
    value: 'MONTHLY'
  },
  {
    label: 'Annually',
    value: 'ANNUALLY'
  }
];

export const status = [
  {
    label: 'Prospect',
    value: 'PROSPECT',
    color: '#5b5b5b'
  },
  {
    label: 'Failed Prospect',
    value: 'FAILED_PROSPECT',
    color: '#9b9b9b'
  },
  {
    label: 'Enquiry',
    value: 'Enquiry',
    color: '#84534C'
  },
  {
    label: 'International Enquiry',
    value: 'INTERNATIONAL_ENQUIRY',
    color: '#84534C'
  },
  {
    label: 'Failed Enquiry',
    value: 'FAILED_ENQUIRY',
    color: '#9b9b9b'
  },
  {
    label: 'Opportunity',
    value: 'OPPORTUNITY',
    color: '#AD4A3D'
  },
  {
    label: 'Failed Opportunity',
    value: 'FAILED_OPPORTUNITY',
    color: '#9B9B9B'
  },
  {
    label: 'Trial',
    value: 'TRIAL',
    color: '#D6412E'
  },
  {
    label: 'Customer',
    value: 'CUSTOMER',
    color: '#1765FF'
  },
  {
    label: 'Influencer',
    value: 'INFLUENCER',
    color: '#8B4F8F'
  },
  {
    label: 'Non Target',
    value: 'NON_TARGET',
    color: '#9B9B9B'
  }
];

export const stage = [
  {
    label: 'Proposal',
    value: 'PROPOSAL'
  },
  {
    label: 'Customer',
    value: 'CUSTOMER'
  },
  {
    label: 'Lead',
    value: 'LEAD'
  },
  {
    label: 'Potential',
    value: 'POTENTIAL'
  }
];

export const category = [
  {
    label: 'Public',
    value: 'PUBLIC'
  },
  {
    label: 'Private',
    value: 'PRIVATE'
  }
];

export const states = [
  {
    label: 'VIC',
    value: 'VIC'
  },
  {
    label: 'NSW',
    value: 'NSW'
  },
  {
    label: 'QLD',
    value: 'QLD'
  },
  {
    label: 'NT',
    value: 'NT'
  },
  {
    label: 'WA',
    value: 'WA'
  },
  {
    label: 'SA',
    value: 'SA'
  },
  {
    label: 'TAS',
    value: 'TAS'
  }
];

export const fieldTypes = [
  {
    label: 'Number',
    value: 'Number'
  },
  {
    label: 'String',
    value: 'STRING'
  }
];

export const orderStages = [
  {
    label: 'Draft',
    value: 'DRAFT',
    color: '#5fa8e7',
    description:
      'Initial stage. Fill in the order details before proceeding to the next stage.'
  },
  {
    label: 'Awaiting PFR',
    value: 'AWAITING_PFR',
    color: '#58a3e5',
    description:
      'PFR documents are awaiting to be signed off by the lead. This status will automatically update when they sign..'
  },
  {
    label: 'PFR Received',
    value: 'PFR_RECEIVED',
    color: '#509ee3',
    description:
      'Yaa, PFR is signed off. Now send the SLA/Direct debit documents.'
  },
  {
    label: 'Awaiting Documents',
    value: 'AWAITING_DOCUMENTS',
    color: '#4094de',
    description:
      'SLA/Direct debit documents are awaiting to be signed off by the lead. This status will automatically update when they sign.'
  },
  {
    label: 'Documents Received',
    value: 'DOCUMENTS_RECEIVED',
    color: '#308ada',
    description:
      'Yaa, documents are signed. Now generate a Winthrop invoice via Xero.'
  },
  {
    label: 'Winthrop Invoice generated',
    value: 'WINTHROP_INVOICE_GENERATED',
    color: '#2885d8',
    description: 'Winthrop invoice is generated via Xero. Now create a sandbox.'
  },
  {
    label: 'Sandbox setup',
    value: 'SETUP_SANDBOX',
    color: '#2080d5',
    description: 'Sandbox has been created, now send order to Winthrop.'
  },
  {
    label: 'Order active',
    value: 'CREATE_WINTHROPE_ORDER',
    color: '#1d74c2',
    description:
      'Winthrop order has been created. Mark this order complete when Winthrop has dispatched the order.'
  },
  // {
  //   label: 'Order active',
  //   value: 'ACTIVE',
  //   color: '#1a69b0',
  //   description:
  //     'Order is activated. It will be set to Completed automatically when its terms expires.'
  // },
  {
    label: 'Completed',
    value: 'COMPLETED',
    color: '#000000',
    description: 'Order is complete. The end.'
  }
];

export const organisationType = [
  {
    label: 'Public',
    value: 'PUBLIC'
  },
  {
    label: 'Private',
    value: 'PRIVATE'
  }
];

export const billingMethod = [
  {
    label: 'Winthrop',
    value: 'WINTHROP'
  },
  {
    label: 'Commonwealth funded program',
    value: 'COMMONWEALTH_FUNDED_PROGRAM'
  }
];

export const metrics = [
  {
    label: 'Opening call - No answer',
    value: 'OPENING_CALL_NO_ANSWER',
    icon: 'CALL',
    color: 'NEUTRAL'
  },
  {
    label: 'Opening call - Not available',
    value: 'OPENING_CALL_NOT_AVAILABLE',
    icon: 'CALL',
    color: 'NEUTRAL'
  },
  {
    label: 'Opening call - Demo booked',
    value: 'OPENING_CALL_DEMO_BOOKED',
    color: 'SUCCESS'
  },
  {
    label: 'Opening call - Information requested',
    value: 'OPENING_CALL_INFORMATION_REQUESTED',
    color: 'SUCCESS'
  },
  {
    label: 'Opening call - Call back',
    value: 'OPENING_CALL_CALL_BACK',
    color: 'NEUTRAL'
  },
  {
    label: 'Opening call - Decline',
    value: 'OPENING_CALL_DECLINE',
    color: 'FAILURE'
  },

  {
    label: 'Followup call - No answer',
    value: 'FOLLOWUP_CALL_NO_ANSWER',
    color: 'WARNING'
  },
  {
    label: 'Followup call - Not available',
    value: 'FOLLOWUP_CALL_NOT_AVAILABLE',
    color: 'WARNING'
  },
  {
    label: 'Followup call - Demo booked',
    value: 'FOLLOWUP_CALL_DEMO_BOOKED',
    color: 'SUCCESS'
  },
  {
    label: 'Followup call - Information requested',
    value: 'FOLLOWUP_CALL_INFORMATION_REQUESTED'
  },
  {
    label: 'Followup call - Call back',
    value: 'FOLLOWUP_CALL_CALL_BACK'
  },
  {
    label: 'Followup call - Decline',
    value: 'FOLLOWUP_CALL_DECLINE'
  },
  {
    label: 'Followup call - Sign up',
    value: 'FOLLOWUP_CALL_SIGN_UP'
  },
  {
    label: 'Followup call - Awaiting feedback',
    value: 'FOLLOWUP_CALL_AWAITING_FEEDBACK'
  },

  {
    label: 'Demonstration/Discussion - No show',
    value: 'DEMONSTRATION_DISCUSSION_NO_SHOW',
    color: 'WARNING'
  },
  {
    label: 'Demonstration/Discussion - Sign up',
    value: 'DEMONSTRATION_DISCUSSION_SIGN_UP',
    color: 'SUCCESS'
  },
  {
    label: 'Demonstration/Discussion - Information requested',
    value: 'DEMONSTRATION_DISCUSSION_INFORMATION_REQUESTED',
    color: 'SUCCESS'
  },
  {
    label: 'Demonstration/Discussion - Awaiting feedback',
    value: 'DEMONSTRATION_DISCUSSION_AWAITING_FEEDBACK',
    color: 'SUCCESS'
  },
  {
    label: 'Demonstration/Discussion - Decline',
    value: 'DEMONSTRATION_DISCUSSION_DECLINE',
    color: 'FAILURE'
  },

  {
    label: 'Email - Opening',
    value: 'EMAIL_OPENING'
  },
  {
    label: 'Email - Follow up',
    value: 'EMAIL_FOLLOW_UP'
  },
  {
    label: 'Email - Information requested',
    value: 'EMAIL_INFORMATION_REQUESTED'
  },

  {
    label: 'Onboarding training',
    value: 'ONBOARDING_TRAINING'
  },

  {
    label: 'Call onboarding',
    value: 'CALL_ONBOARDING'
  },
  {
    label: 'Email onboarding',
    value: 'EMAIL_ONBOARDING'
  },
  {
    label: 'Call customer service',
    value: 'CALL_CUSTOMER_SERVICE'
  },
  {
    label: 'Email customer service',
    value: 'EMAIL_CUSTOMER_SERVICE'
  }
];

let string =
  '[{"label":"Aged Care Residential Services","value":"8601","code":"ANZSIC"},{"label":"Ambulance Services","value":"8591","code":"ANZSIC"},{"label":"Call Centre Operation","value":"7294","code":"ANZSIC"},{"label":"Central Government Healthcare Administration","value":"7511","code":"ANZSIC"},{"label":"Child Care Services","value":"8710","code":"ANZSIC"},{"label":"Chiropractic and Osteopathic Services","value":"8534","code":"ANZSIC"},{"label":"Computer System Design and Related Services","value":"7000","code":"ANZSIC"},{"label":"Corporate Head Office Management Services","value":"6961","code":"ANZSIC"},{"label":"Data Processing and Web Hosting Services","value":"5921","code":"ANZSIC"},{"label":"Dental Services","value":"8531","code":"ANZSIC"},{"label":"Electronic Information Storage Services","value":"5922","code":"ANZSIC"},{"label":"General Health Administration","value":"7561","code":"ANZSIC"},{"label":"General Practice","value":"8511","code":"ANZSIC"},{"label":"Health and Fitness Centres and Gymnasia Operation","value":"9111","code":"ANZSIC"},{"label":"Health Insurance","value":"6321","code":"ANZSIC"},{"label":"Higher Education","value":"8102","code":"ANZSIC"},{"label":"Hospitals (except Psychiatric Hospitals)","value":"8401","code":"ANZSIC"},{"label":"Internet Service Providers and Web Search Portals","value":"5910","code":"ANZSIC"},{"label":"Local Government Healthcare Administration","value":"7531","code":"ANZSIC"},{"label":"Mental Health Hospitals","value":"8402","code":"ANZSIC"},{"label":"Office Administrative Services","value":"7291","code":"ANZSIC"},{"label":"Optometry and Optical Dispensing","value":"8532","code":"ANZSIC"},{"label":"Other Allied Health Services","value":"8539","code":"ANZSIC"},{"label":"Other Healthcare Services nec","value":"8599","code":"ANZSIC"},{"label":"Other Professional, Scientific and Technical Services n.e.c.","value":"6999","code":"ANZSIC"},{"label":"Other Residential Care Services","value":"8609","code":"ANZSIC"},{"label":"Other Social Assistance Services","value":"8790","code":"ANZSIC"},{"label":"Pathology and Diagnostic Imaging Services","value":"8520","code":"ANZSIC"},{"label":"Physiotherapy Services","value":"8533","code":"ANZSIC"},{"label":"Provision and administration of public health program","value":"7562","code":"ANZSIC"},{"label":"Retail Pharmacy","value":"4271","code":"ANZSIC"},{"label":"Scientific Research Services","value":"6910","code":"ANZSIC"},{"label":"Specialist Medical Services","value":"8512","code":"ANZSIC"},{"label":"State Government Healthcare Administration","value":"7521","code":"ANZSIC"}]';

export const facilityTypeCodes = JSON.parse(string);

export const practiceSettingTypes = [
  { label: 'Acupuncture service', value: '8539-1' },
  { label: 'Adoption service', value: '8790-1' },
  { label: 'Adult day care centre operation', value: '8790-2' },
  { label: 'Aerial ambulance service', value: '8591-1' },
  { label: 'Aged care assistance service', value: '8790-3' },
  { label: 'Alcoholics anonymous operation', value: '8790-4' },
  { label: 'Allergy specialist service', value: '8512-1' },
  { label: 'Ambulance service', value: '8591-2' },
  { label: 'Anaesthetist service', value: '8512-2' },
  { label: 'Application hosting', value: '5921-1' },
  { label: 'Application service provision', value: '5921-2' },
  { label: 'Aromatherapy service', value: '8539-2' },
  { label: 'Audio and visual media streaming service', value: '5921-3' },
  { label: 'Audiology service', value: '8539-3' },
  { label: 'Automated data processing service', value: '5921-4' },
  { label: 'Before and/or after school care service', value: '8710-1' },
  { label: 'Billing and record-keeping service', value: '7291-1' },
  { label: 'Blood bank operation', value: '8599-1' },
  { label: 'Business administrative service', value: '7291-2' },
  { label: 'Charitable hostels for the aged', value: '8601-5' },
  { label: 'Child care service', value: '8710-2' },
  { label: 'Childminding service', value: '8710-3' },
  { label: "Children's Hospital", value: '8401-1' },
  {
    label: "Children's nursery operation (except preschool education)",
    value: '8710-4'
  },
  { label: "Children's play programs", value: '8710-6' },
  { label: 'Chiropractic', value: '8534-1' },
  { label: 'Clerical service', value: '7291-3' },
  { label: 'Clinical psychology service', value: '8539-4' },
  { label: 'Colleges of education operation', value: '8102-1' },
  { label: 'Community Health Care', value: '8511-5' },
  { label: 'Community Health Facility', value: '8599-4' },
  { label: 'Community health facility - mental', value: '8599-8' },
  { label: 'Community health facility - other', value: '8599-9' },
  { label: 'Community health facility - substance abuse', value: '8599-7' },
  { label: 'Community Pharmacy', value: '4271-2' },
  {
    label:
      'Computer data storage and retrieval service (except library service)',
    value: '5922-1'
  },
  { label: 'Computer hardware consulting service', value: '7000-1' },
  { label: 'Computer input preparation service', value: '5921-5' },
  { label: 'Computer programming service', value: '7000-2' },
  { label: 'Computer software consulting service', value: '7000-3' },
  { label: 'Computer time leasing or renting', value: '5921-6' },
  { label: 'Computer time sharing service', value: '5921-7' },
  { label: 'Conservative dental service', value: '8531-1' },
  { label: 'Contact lens dispensing', value: '8532-1' },
  { label: 'Corporate head office management', value: '6961-1' },
  { label: 'Data capture imaging service', value: '5921-8' },
  { label: 'Data entry service (electronic)', value: '5921-9' },
  { label: 'Data processing computer service', value: '5921-10' },
  { label: 'Day Hospital nec', value: '8401-2' },
  { label: 'Defence Force Hospital', value: '8401-18' },
  { label: 'Dental hospital (out-patient)', value: '8531-2' },
  { label: 'Dental hygiene service', value: '8539-5' },
  { label: 'Dental insurance provision', value: '6321-1' },
  { label: 'Dental practice service', value: '8531-3' },
  { label: 'Dental practitioner service', value: '8531-4' },
  { label: 'Dental surgery service', value: '8531-5' },
  { label: 'Dermatology Service', value: '8512-3' },
  { label: 'Diagnostic imaging service', value: '8520-1' },
  { label: 'Dietician service', value: '8539-6' },
  { label: 'Disabilities assistance service', value: '8790-5' },
  {
    label: 'Disk and diskette conversion and recertification service',
    value: '5921-11'
  },
  { label: 'Divisions of General Practice', value: '7511-1' },
  { label: 'Ear, nose and throat hospital', value: '8401-3' },
  { label: 'Ear, nose and throat specialist service', value: '8512-4' },
  { label: 'Electronic data processing service', value: '5921-12' },
  { label: 'Emergency Department Services', value: '8512-19' },
  { label: 'Endodontic service', value: '8531-6' },
  { label: 'Extended Allied Health services', value: '8539-18' },
  { label: 'Eye Hospital', value: '8401-4' },
  { label: 'Eye testing (optometrist)', value: '8532-2' },
  { label: 'Family day care service', value: '8710-5' },
  { label: 'Flying doctor service', value: '8511-1' },
  { label: 'Funeral benefit provision', value: '6321-2' },
  { label: 'General Health Administration', value: '7561-1' },
  { label: 'General Hospital', value: '8401-5' },
  { label: 'General medical practitioner service', value: '8511-2' },
  { label: 'General practice medical clinic service', value: '8511-3' },
  { label: 'Government nursing home for the aged', value: '8601-2' },
  { label: 'Government nursing home for young disabled', value: '8609-3' },
  { label: 'Gynaecology services', value: '8512-5' },
  {
    label: 'Hair transplant service (by registered medical practitioner)',
    value: '8512-6'
  },
  {
    label: 'Health and Fitness Centres and Gymnasia Operation',
    value: '9111-1'
  },
  { label: 'Health assessment service', value: '8599-2' },
  { label: 'Health insurance provision', value: '6321-3' },
  { label: 'Healthcare service nec', value: '8599-3' },
  { label: 'Hearing aid dispensing', value: '8539-7' },
  { label: 'Herbalist service', value: '8539-8' },
  { label: 'Homoeopathic service', value: '8539-9' },
  {
    label: 'Hospital (except psychiatric or veterinary hospitals)',
    value: '8401-6'
  },
  { label: 'Hydropathic service', value: '8539-10' },
  {
    label: 'Infectious diseases hospital (including human quarantine stations)',
    value: '8401-7'
  },
  { label: 'Internet access provision', value: '5910-1' },
  { label: 'Internet access service, on-line', value: '5910-2' },
  { label: 'Internet and web design consulting service', value: '7000-4' },
  { label: 'Internet search portal operation', value: '5910-3' },
  { label: 'Internet search web site operation', value: '5910-4' },
  { label: 'Internet service provision (ISP)', value: '5910-5' },
  { label: 'Interpretation service', value: '6999-1' },
  { label: 'Local Government Healthcare Administration', value: '7531-1' },
  { label: 'Local government hostel for the aged', value: '8601-6' },
  { label: 'Marriage guidance service', value: '8790-6' },
  { label: 'Maternity Hospital', value: '8401-8' },
  { label: 'Medical laboratory service', value: '8520-2' },
  { label: 'Medical research service', value: '6910-1' },
  {
    label: 'Microfiche or microfilm recording and imaging service',
    value: '5921-13'
  },
  { label: 'Midwifery service', value: '8539-11' },
  { label: 'Naturopathic service', value: '8539-12' },
  { label: 'Neurology service', value: '8512-7' },
  { label: 'Nursing service', value: '8539-13' },
  { label: 'Obstetrics service', value: '8512-8' },
  { label: 'Obstretic Hospital', value: '8401-9' },
  { label: 'Occupational therapy service', value: '8539-14' },
  { label: 'Office administrative service n.e.c.', value: '7291-4' },
  { label: 'Operation of soup kitchen (including mobile)', value: '8790-7' },
  { label: 'Ophthalmology service', value: '8512-9' },
  { label: 'Optical dispensing', value: '8532-3' },
  { label: 'Optical scanning service', value: '5921-14' },
  { label: 'Optician service', value: '8532-4' },
  { label: 'Oral pathology service', value: '8531-7' },
  { label: 'Oral surgery service', value: '8531-8' },
  { label: 'Orthodontic service', value: '8531-9' },
  { label: 'Orthopaedic service', value: '8512-10' },
  { label: 'Orthoptic service', value: '8532-5' },
  { label: 'Osteopathic Services', value: '8534-2' },
  { label: 'Other charitable hostel', value: '8609-4' },
  { label: 'Other Commonwealth Hospital', value: '8401-19' },
  { label: 'Other Local government hostel', value: '8609-6' },
  { label: 'Other State government hostel', value: '8609-5' },
  { label: 'Paediatric service', value: '8512-11' },
  { label: 'Pathology laboratory service', value: '8520-3' },
  { label: 'Payroll processing', value: '7291-5' },
  { label: 'Pedodontics service', value: '8531-10' },
  { label: 'Periodontic service', value: '8531-11' },
  { label: 'Pharmacy, retail, operation', value: '4271-1' },
  { label: 'Physiotherapy Services', value: '8533-1' },
  { label: 'Podiatry service', value: '8539-15' },
  { label: 'Portal web search operation', value: '5910-6' },
  { label: 'Postgraduate school, university operation', value: '8102-2' },
  { label: 'Private (non-profit)', value: '8599-6' },
  { label: 'Private acute care Hospital', value: '8401-16' },
  { label: 'Private alcohol and drug treatment centre', value: '8609-8' },
  { label: 'Private charitable nursing home for the aged', value: '8601-3' },
  {
    label: 'Private charitable nursing home for young disabled',
    value: '8609-1'
  },
  { label: 'Private day centre/hospital.', value: '8401-13' },
  { label: 'Private freestanding day surgery centre.', value: '8401-14' },
  { label: 'Private Mental Health Hospital', value: '8402-2' },
  { label: 'Private profit nursing home for the aged', value: '8601-1' },
  { label: 'Private profit nursing home for young disabled', value: '8609-2' },
  {
    label: 'Professional, scientific and technical services n.e.c.',
    value: '6999-2'
  },
  { label: 'Prosthodontics service', value: '8531-12' },
  {
    label: 'Provision and administration of public health program',
    value: '7562-1'
  },
  { label: 'Psychiatry service', value: '8512-12' },
  { label: 'Public acute care Hospital', value: '8401-15' },
  { label: 'Public alcohol and drug treatment centre', value: '8609-7' },
  { label: 'Public Community Health Centre', value: '8599-5' },
  { label: 'Public day centre/hospital', value: '8401-11' },
  { label: 'Public freestanding day surgery centre.', value: '8401-12' },
  { label: 'Public Mental Health Hospital', value: '8402-1' },
  { label: 'Reception service', value: '7291-6' },
  { label: 'Research school, university operation', value: '8102-3' },
  { label: 'Rheumatology service', value: '8512-13' },
  { label: 'Rural general medical practice service', value: '8511-4' },
  { label: 'Social science research service', value: '6910-2' },
  { label: 'Software development (customised)', value: '7000-5' },
  { label: 'Software installation service', value: '7000-6' },
  { label: 'Specialist institute or college', value: '8102-4' },
  { label: 'Specialist medical clinic service', value: '8512-14' },
  { label: 'Specialist medical practitioner service nec', value: '8512-15' },
  { label: 'Specialist surgical service', value: '8512-16' },
  { label: 'Spectacles dispensing', value: '8532-6' },
  { label: 'Speech pathology service', value: '8539-16' },
  { label: 'State Government Healthcare Administration', value: '7521-1' },
  { label: 'State government hostel for the aged', value: '8601-4' },
  { label: 'Subacute Hospitals', value: '8401-20' },
  { label: 'Systems analysis service', value: '7000-7' },
  { label: "Teachers' college operation", value: '8102-5' },
  { label: 'Telephone answering service', value: '7294-1' },
  { label: 'Telephone call centre operation', value: '7294-2' },
  { label: 'Therapeutic massage service', value: '8539-17' },
  { label: 'Thoracic specialist service', value: '8512-17' },
  { label: 'Translation service', value: '6999-3' },
  { label: 'Transport', value: '4623-1' },
  { label: 'Undergraduate school, university operation', value: '8102-6' },
  { label: 'University operation', value: '8102-7' },
  { label: 'Urology service', value: '8512-18' },
  { label: 'Veterans Affairs Hospital', value: '8401-17' },
  { label: 'Voice mailbox service', value: '7294-3' },
  { label: 'Web hosting', value: '5921-15' },
  { label: 'Web search portal operation', value: '5910-7' },
  { label: 'Welfare counselling service', value: '8790-8' },
  { label: "Women's Hospital", value: '8401-10' },
  { label: 'X-ray clinic service', value: '8520-4' },
  { label: 'Youth welfare service', value: '8790-9' },
  { label: 'TBD', value: 'TBD' }
];
